import { useEffect, useState, useRef } from "react";

import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  getSelectedCase,
  getSingleParty,
  setToggle,
  setToggle_2,
  toggleState,
  toggleState_2,
} from "../../../states/slices/partyInfo.slice";
import { TableComponent } from "../../../components/table/Table";
import { PARTY_COLUMNS_view } from "../../../components/table/columns";
import Typography from "../../../components/Typography";
import {
  CHEVRON_LEFT,
  FLAG,
  MINUS,
  PDF_ICON,
  PLUS,
  QUESTION,
} from "../../../assets";
import {
  fetchPageOptions,
  formatCurrency,
  getJSONheader,
} from "../../../utils";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/button";
import Api from "../../../config";
import { useGetPaymentsQuery } from "../../../services/apis/cases";
import { toast } from "react-hot-toast";
import PartyInformation from "../../../components/modals/Partinformation";
import FillingFee from "../../../components/modals/FillingFee";
import { PDFDocument, rgb, degrees } from "pdf-lib";
import { selectUser } from "../../../states/slices/authReducer";
import Modal from "../../../components/UI/modal";

import Preloader from "../../../components/preloader";
import moment from "moment";

import { Loader2 } from "lucide-react";

function ProcessPayment() {
  const getCase = useAppSelector(getSelectedCase);
  const [pdfBytes, setPdfBytes] = useState<any>(null);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(3);
  const [docId, setDocId] = useState<any>(null);
  const navigate = useNavigate();
  const [remark, setRemark] = useState<any>("");
  const [waiver, setWaiver] = useState<any>(1);
  const [bgColor, setBgColor] = useState<any>("bg-red-700");
  const user = useAppSelector(selectUser);
  const [paymentID, setPaymentID] = useState<any>();
  const [remarkRequire, setRemarkRequire] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [waiverloading, setWaiverLoading] = useState<boolean>(false);
  const [rjloading, setRjLoading] = useState<boolean>(false);
  const toggleStatus = useAppSelector(toggleState);
  const toggleStatus_2 = useAppSelector(toggleState_2);
  const singlePartyInfo = useAppSelector(getSingleParty);
  const dispatch = useAppDispatch();
  const [products, setProducts] = useState<any[]>(getCase?.case_documents);
  const [totalPrice, setTotalPrice] = useState<number>();
  const [open, setOpen] = useState(false);
  const [blobUrl, setBlobUrl] = useState<any>(null);
  const [activeCaseInView, setActiveCaseInView] = useState<any>(null);
  const [loadingReceipt, setLoadingReceipt] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState<any>(null);
  const [viewOnly, setViewOnly] = useState(false);

  const [openReceiptViewer, setOpenReceiptViewer] = useState(false);
  const [passReceiptUrl, setPassReceiptUrl] = useState<string>("");
  const pageOptionsRef = useRef<HTMLDivElement>(null);
  const lastVerifiedReferenceRef = useRef<string | null>(null);
  const [preloaderState, setPreloaderState] = useState<
    "creating" | "almostDone" | "success" | "error" | null
  >(null);
  const [pageLoaderState, setPageLoaderState] = useState<
    "creating" | "almostDone" | "success" | "error" | null
  >(null);
  const [suitNumberBtnClicked, setSuitNumberBtnClicked] = useState<
    "creating" | "almostDone" | "success" | "error" | null
  >(null);
  const [pageLoader, setPageLoader] = useState<
    "creating" | "almostDone" | "success" | "error" | null
  >(null);
  const [verifyLoader, setVerifyLoader] = useState<
    "creating" | "almostDone" | "success" | "error" | null
  >(null);

  const [targetPageIndex, setTargetPageIndex] = useState(0);
  const [pageOptions, setPageOptions] = useState<number[]>([]);
  const [showPageSelector, setShowPageSelector] = useState(false);
  const [positionValue, setPositionValue] = useState("");
  const [showOptionsSelector, setShowOptionsSelector] = useState(false);
  const positionOptionsRef = useRef<HTMLDivElement>(null);
  // const [showJoinedCase, setShowJoinedCase] = useState(false);
  const [selectedCaseDocumentId, setSelectedCaseDocumentId] = useState<
    string | null
  >(null);

  // const filterJoinedDoc = getCase?.case_documents?.filter(
  //   (doc: any) => doc.joined === 1
  // );

  const handlePageSelection = (index: number) => {
    setTargetPageIndex(index);
    setOpen(true);
    setBlobUrl(selectedDoc?.file_path);
    setShowPageSelector(false); // Close the selector
    setShowOptionsSelector(true);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        pageOptionsRef.current &&
        !pageOptionsRef.current.contains(event.target as Node)
      ) {
        setShowPageSelector(false);
      } else if (
        positionOptionsRef.current &&
        !positionOptionsRef.current.contains(event.target as Node)
      ) {
        setShowOptionsSelector(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const handleInputChange = (index: any, event: any) => {
    const { value } = event.target;

    setProducts((prevProducts) => {
      // const updatedProducts = [...prevProducts];
      // updatedProducts[index].price = value;
      const updatedProducts = prevProducts.map((product, i) => ({
        ...product,
        price: i === index ? value : product.price,
      }));
      // Calculate the total sum
      const total = updatedProducts.reduce((sum, product) => {
        if (product.status === "UNPAID" || product.status === "DEFAULT") {
          return sum + (parseFloat(product.price) || 0); // Convert price to a number before adding
        }
        return sum;
      }, 0);

      setTotalPrice(total); // Update the total state variable

      return updatedProducts;
    });
  };

  useEffect(() => {
    fetchDataFromBackend();
  }, [getCase?.case_documents]);

  const fetchDataFromBackend = () => {
    // Simulated data from the backend

    const updatedProducts =
      activeCaseInView?.case_documents?.map((data: any) => ({
        ...data,
        case_document_id: data.id,
        file_path: data.file_path,
        title: data.title,
        price: data.price || 0,
      })) ||
      getCase?.case_documents?.map((data: any) => ({
        ...data,
        case_document_id: data.id,
        file_path: data.file_path,
        title: data.title,
        price: data.price || 0,
      })) ||
      [];

    setProducts(updatedProducts);

    // Initial total calculation for UNPAID documents
    const initialTotal = updatedProducts.reduce((sum: number, product: any) => {
      if (product.status === "UNPAID") {
        return sum + (parseFloat(product.price) || 0);
      }
      return sum;
    }, 0);
    setTotalPrice(initialTotal);
  };

  const { paymentData, isLoadingCases, refetch } = useGetPaymentsQuery(null, {
    selectFromResult: ({ data, isLoading, isError }: any) => ({
      paymentData: data?.data,
      isLoadingCases: isLoading,
    }),
  });

  useEffect(() => {
    handlePaymentData(paymentData);
  }, [paymentData]);

  useEffect(() => {
    refetch();
  }, [page]);

  const handlePaymentData = (paymentData: any[]) => {
    paymentData?.map((item: any) => {
      if (item?.service?.id === getCase?.id) {
        // console.log(item, 'ddd');

        setPaymentID(item);
        return item;
      }
    });
  };

  const handleSubmitToRegistrar_2 = async () => {
    setLoading(true);
    Api.post(
      `/registra1/case-folders/${getCase?.id}/submit`,
      {
        court: "HIGH COURT",
      },
      getJSONheader(),
    )
      .then((res) => {
        toast.success(`${res?.data.message}`, {
          duration: 3000,
        });
        // console.log(res.data);

        setLoading(false);

        navigate("/registrar-1/case-folders");
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error?.response?.data?.message, {
          duration: 3000,
        });
      });
  };

  const handleAdvisePayment = async () => {
    if (remark) {
      setLoading(true);

      const productTosend = (products || [])
        .filter(
          (item: any) =>
            item?.status === "UNPAID" || item?.status === "DEFAULT",
        )
        .map((item: any) => ({
          case_document_id: item?.case_document_id || item?.id,
          price: Number(item?.price) || 0,
        }));

      const FilteredJoinedCase = products
        .filter(
          (item: any) =>
            item?.joined === 1 &&
            (item?.status === "UNPAID" || item?.status === "DEFAULT"),
        )
        .map((item_) => ({
          case_document_id: item_?.case_document_id || item_?.id,
          price: Number(item_?.price) || 0,
        }));

      const payload = {
        require_payment: true,
        remark: remark,
        callback_url: `${window.location.origin}/lawyer/my-files`,
        case_documents:
          activeCaseInView?.case_status.status === "JOIN REQUEST"
            ? FilteredJoinedCase
            : productTosend,
      };

      console.log(payload);

      Api.post(
        `/registra1/case-folders/${getCase?.id}/advice-payment`,
        payload,
        getJSONheader(),
      )
        .then((res) => {
          toast.success(`${res?.data.message}`, {
            duration: 3000,
          });
          // console.log(res.data);

          setLoading(false);

          navigate("/registrar-1/case-folders");
        })
        .catch((error: any) => {
          setLoading(false);
          toast.error(error?.response?.data?.message, {
            duration: 3000,
          });
        });
    } else {
      setRemarkRequire("A remark is required");
    }
  };
  const handleReject = () => {
    if (remark) {
      setRjLoading(true);
      Api.post(
        `/registra1/case-folders/${getCase?.id}/reject`,
        { remark: remark },
        getJSONheader(),
      )
        .then((res) => {
          // console.log(res);
          navigate("/registrar-1/case-folders");
          toast.success(`${res?.data.message}`, {
            duration: 3000,
          });
          setRjLoading(false);
        })
        .catch((error) => {
          setRjLoading(false);
          toast.error(error?.response?.data?.message, {
            duration: 3000,
          });
        });
    } else {
      setRemarkRequire("A remark is required");
    }
  };

  useEffect(() => {
    fetchDataFromBackend();
  }, [getCase?.case_documents]);

  useEffect(() => {
    handlePaymentData(paymentData);
  }, [paymentData]);

  useEffect(() => {
    refetch();
  }, [page]);

  const handleWaiver = () => {
    setWaiverLoading(true);
    if (waiver === 0) {
      Api.put(
        `/registra1/case-folders/${getCase?.id}/set-payment-option`,
        { require_payment: waiver },
        getJSONheader(),
      )
        .then((res) => {
          // console.log(res);
          setBgColor("bg-red-700");
          setWaiverLoading(false);
          setWaiver(1);

          toast.success(`Waiver have been added successfully`, {
            duration: 3000,
          });
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message, {
            duration: 3000,
          });
          setWaiverLoading(false);
        });
    } else if (waiver === 1) {
      Api.put(
        `/registra1/case-folders/${getCase?.id}/set-payment-option`,
        { require_payment: waiver },
        getJSONheader(),
      )
        .then((res) => {
          // console.log(res);
          setBgColor("bg-green-700");
          setWaiver(0);
          setWaiverLoading(false);
          toast.success(`Waiver have been removed successfully`, {
            duration: 3000,
          });
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message, {
            duration: 3000,
          });
          setWaiverLoading(false);
        });
    }
  };

  const addSuitNumber = async (pdf: string, item: any, suitNumber: string) => {
    try {
      const existingPdfBytes = await fetch(pdf).then((res) =>
        res.arrayBuffer(),
      );

      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();

      pages.forEach((page) => {
        page.drawText(`Suit No: ${suitNumber}`, {
          x: 50,
          y: page.getHeight() - 50,
          size: 12,
          color: rgb(0, 0, 0),
        });
      });

      const pdfBytes = await pdfDoc.save();
      // @ts-ignore
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      const file = new File([blob], "suit-number-added.pdf", {
        type: "application/pdf",
      });

      await handleUpdateDoc(file, item);

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error adding suit number to PDF:", error);
      toast.error("Failed to add suit number to the document.", {
        duration: 3000,
      });
    }
  };
  const [receiptModalOpen, setReceiptModalOpen] = useState(false);
  const [selectedReceiptData, setSelectedReceiptData] = useState<any>(null);

  const fetchReceipt = async (docId: string) => {
    setLoadingReceipt(true);
    setDocId(docId);
    try {
      const response = await Api.get(
        `/case-documents/${docId}/payment`,
        getJSONheader(),
      );
      if (response?.data?.data) {
        setSelectedReceiptData(response.data.data);
        setReceiptModalOpen(true);
      }
    } catch (error: any) {
      console.error("Error fetching receipt:", error);
      toast.error(error?.response?.data?.message || "Failed to fetch receipt");
    } finally {
      setLoadingReceipt(false);
    }
  };

  const ViewReceiptModal = () => {
    const payment = selectedReceiptData?.payment;
    const document = selectedReceiptData?.case_document;

    return (
      <Modal
        open={receiptModalOpen}
        close={() => {
          setReceiptModalOpen(false);
          setSelectedReceiptData(null);
        }}
        maxWidth="md"
      >
        <div className="p-6">
          <Typography textStyle="text-xl font-bold mb-4">
            Payment Receipt
          </Typography>

          {payment && (
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div>
                <p className="text-gray-600 text-sm">Total Amount Paid</p>
                <p className="font-semibold text-lg">
                  {formatCurrency({ iso: "en-ng", slug: "NGN" }).format(
                    payment.amount,
                  )}
                </p>
              </div>
              <div>
                <p className="text-gray-600 text-sm">Payment Method</p>
                <p className="font-medium capitalize">{payment.method}</p>
              </div>
              <div>
                <p className="text-gray-600 text-sm">Reference</p>
                <p className="font-medium">{payment.reference}</p>
              </div>
              <div>
                <p className="text-gray-600 text-sm">Status</p>
                <span
                  className={`px-2 py-1 rounded text-xs font-medium ${
                    payment.status === "success"
                      ? "bg-green-100 text-green-800"
                      : "bg-yellow-100 text-yellow-800"
                  }`}
                >
                  {payment.status}
                </span>
              </div>
              <div>
                <p className="text-gray-600 text-sm">Transaction Date</p>
                <p className="font-medium">
                  {payment.created_at
                    ? moment(payment.created_at).format("MMM DD, YYYY HH:mm")
                    : "N/A"}
                </p>
              </div>
            </div>
          )}

          {document && (
            <div className="mb-6 border-t pt-4">
              <Typography textStyle="text-lg font-semibold mb-2">
                Document Details
              </Typography>
              <div className="flex justify-between items-center bg-gray-50 p-3 rounded">
                <div>
                  <p className="font-medium">{document.title}</p>
                  <p className="text-xs text-gray-500">
                    Price:{" "}
                    {formatCurrency({ iso: "en-ng", slug: "NGN" }).format(
                      document.price,
                    )}
                  </p>
                </div>
              </div>
            </div>
          )}

          {payment?.file_path && (
            <div className="border-t pt-4">
              <Typography textStyle="text-lg font-semibold mb-2">
                Receipt Image
              </Typography>
              <div className="flex justify-center bg-gray-100 p-4 rounded">
                <img
                  src={payment.file_path}
                  alt="Payment Receipt"
                  className="max-h-[400px] object-contain"
                />
              </div>
            </div>
          )}
        </div>
      </Modal>
    );
  };

  const handleUpdateDoc = async (file: File, item: any) => {
    console.log(item?.case_document_id || item?.id);

    try {
      const formData = new FormData();
      console.log("item");
      console.log(item);
      const fileBlob = new Blob([file], { type: "application/pdf" });
      formData.append("file_path", fileBlob, "file.pdf");

      const res: any = await Api.post(
        `registra1/case-documents/${item?.case_document_id || item?.id}/update`,
        formData,
      );
      console.log(res, "eeee");

      if (res) {
        setTimeout(() => setPreloaderState("almostDone"), 1000);

        setTimeout(() => {
          setPreloaderState("success");

          toast.success(res?.data?.message);
          setViewOnly(true);
          setBlobUrl(res?.data?.data?.file_path);
        }, 2000);
      }
    } catch (error: any) {
      setPreloaderState("error");
      toast.error(error?.response?.data?.message, {
        duration: 3000,
      });
    } finally {
      setTimeout(() => {
        setPreloaderState(null);
      }, 3000);
    }
  };

  const HandleViewOnlyDoc = () => {
    return (
      <Modal
        open={viewOnly}
        close={() => {
          setViewOnly(false);
          setBlobUrl(null);
        }}
        maxWidth="lg"
      >
        <iframe
          title="PDF Viewer"
          src={`${blobUrl}#page=${targetPageIndex + 1}`}
          className="w-full"
          height={900}
        />
      </Modal>
    );
  };

  const handleAppendClick = async (file_path: string, doc: any) => {
    setSelectedDoc(doc);
    setPageLoaderState("creating");
    try {
      const options = await fetchPageOptions(file_path); // Pass the PDF URL
      if (options) {
        setTimeout(() => {
          setPageLoaderState("almostDone");
        }, 1000);
        setTimeout(() => {
          toast.success("Fetched pdf pages successfully");
          setPageOptions(options);
          setShowPageSelector(true);
        }, 2000);
      }
    } catch (error) {
      console.error("Error fetching pages:", error);
    } finally {
      setTimeout(() => {
        setPageLoaderState(null);
      }, 2000);
    }
  };
  const handlePagePositionSelect = (position: string) => {
    setPositionValue(position);

    setShowOptionsSelector(false);
  };

  const handleAddStampToDocument = async () => {
    if (!selectedCaseDocumentId) {
      toast.error("No selected case document");
      return;
    }
    setPreloaderState("creating");
    setPositionValue("");

    setOpen(false);

    const payload = {
      page: targetPageIndex + 1,
      position: positionValue,
    };

    try {
      const response: any = await Api.post(
        `/registra1/case-documents/${selectedCaseDocumentId}/stamp`,
        payload,
      );

      if (response) {
        setTimeout(() => setPreloaderState("almostDone"), 1000);

        setTimeout(() => {
          setPreloaderState("success");

          toast.success(response?.data?.message);
          setViewOnly(true);
          setBlobUrl(response?.data?.data?.file_path);
        }, 2000);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      setPreloaderState("error");
    } finally {
      setTimeout(() => {
        setPreloaderState(null);
      }, 2000);
    }
  };
  // const [paymentReceipt, setPaymentReceipt] = useState([]);
  // const getPaymentReceipt = async () => {
  //   try {
  //     const response = await Api.get(
  //       `/registra1/case-folders/${getCase?.id}/proof-of-payment`,
  //       getJSONheader(),
  //     );
  //     if (response) {
  //       setPaymentReceipt(response?.data?.data);
  //     }
  //   } catch (error: any) {
  //     console.log(error?.response?.data?.message);
  //   }
  // };

  // useEffect(() => {
  //   getPaymentReceipt();
  // }, [getCase?.id]);

  const HandleViewReceipt = () => {
    return (
      <Modal
        open={openReceiptViewer}
        close={() => {
          setOpenReceiptViewer(false);
          setPassReceiptUrl("");
        }}
        maxWidth="sm"
      >
        <div className="flex items-center justify-center pb-10">
          <img
            src={passReceiptUrl}
            className="w-[400px] h-[400px] object-cover"
            alt=""
          />
        </div>
      </Modal>
    );
  };

  useEffect(() => {
    setProducts(activeCaseInView?.case_documents || getCase?.case_documents);
  }, [activeCaseInView]);

  const showCaseFolder = async () => {
    setPageLoader("creating");
    try {
      const response = await Api.get(
        `/registra1/case-folders/${getCase?.id}`,
        getJSONheader(),
      );
      if (response) {
        setActiveCaseInView(response.data.data);
      }
    } catch (error: any) {
      console.log(error?.response?.data?.message);
    } finally {
      setPageLoader(null);
    }
  };

  useEffect(() => {
    showCaseFolder();
  }, [getCase?.id]);

  // const verifyPaymentReference = async (reference: string) => {
  //   setVerifyLoader("creating");
  //   try {
  //     const response = await Api.post(
  //       `/registra1/payments/verify`,
  //       { reference },
  //       getJSONheader(),
  //     );
  //     setVerifyLoader("almostDone");
  //     setTimeout(() => {
  //       setVerifyLoader("success");
  //       toast.success(response?.data?.message || "Payment verified");
  //       showCaseFolder();
  //     }, 800);
  //   } catch (error: any) {
  //     setVerifyLoader("error");
  //     toast.error(
  //       error?.response?.data?.message || "Payment failed to verified",
  //     );
  //     console.error("Error verifying payment:", error);
  //   } finally {
  //     setTimeout(() => setVerifyLoader(null), 3000);
  //   }
  // };

  // useEffect(() => {
  //   const caseStatus = activeCaseInView?.case_status?.status;
  //   if (caseStatus !== "MAKE_PAYMENT") return;
  //   const reference = activeCaseInView?.payment?.reference;
  //   if (!reference) return;
  //   if (lastVerifiedReferenceRef.current === reference) return;
  //   lastVerifiedReferenceRef.current = reference;
  //   verifyPaymentReference(reference);
  // }, [activeCaseInView?.payment?.reference]);

  const getFlagStyle = (role: string) => {
    switch (role) {
      case "DEFENDANT":
        return "bg-[#FFECEB] text-[#C62828]";
      case "PLAINTIFF":
        return "bg-[#E3F2FD] text-[#1565C0]";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  const hasUnpaidDoc = activeCaseInView?.case_documents?.some(
    (doc: any) => doc?.status === "UNPAID" || doc.status === "DEFAULT",
  );

  return (
    <>
      <div className="bg-[#F8F8F9E5]/90  w-full py-2 px-8">
        <Typography textStyle="text-base">{`My Files  / ${activeCaseInView?.title}`}</Typography>
      </div>
      {hasUnpaidDoc && (
        <div className="flex justify-end gap-x-5 items-center mt-4 pr-8">
          <Button
            isLoading={waiverloading}
            icons={waiver === 0 ? PLUS : MINUS}
            iconClassName="h-[0.9rem] w-3"
            title={waiver === 0 ? "Add Fee Waiver" : "Remove Waiver"}
            bgColor={bgColor}
            onClick={() => handleWaiver()}
            hoverColor={""}
            textColor={"text-white"}
            className={"py-2 rounded-lg"}
          />
          {/* {getCase?.case_status?.status === "JOIN REQUEST" && (
            <Button
              // isLoading={waiverloading}
              // icons={waiver === 0 ? PLUS : MINUS}
              iconClassName="h-[0.9rem] w-3"
              title={showJoinedCase ? "Hide Joined Case" : "View Joined Case"}
              bgColor={showJoinedCase ? "bg-gray-500" : "bg-green-500"}
              onClick={() => setShowJoinedCase((prev) => !prev)}
              hoverColor={""}
              textColor={"text-white"}
              className={"py-2 rounded-lg"}
            />
          )} */}
        </div>
      )}
      <div className="pt-4 pb-8 px-4 lg:px-8">
        <Typography textStyle="text-[20px] font-medium">
          Party Information
        </Typography>
        <div className="my-2">
          {activeCaseInView?.parties?.length > 0 ? (
            <TableComponent
              className="rounded-none rounded-t-0"
              DATA={activeCaseInView?.parties}
              COLUMNS={PARTY_COLUMNS_view}
              TITLE=""
              isExport={null}
              isPaginated={null}
              isSearch={null}
              size={size}
              setSize={setSize}
              setPageIndex={(value: number) => page + 1}
            />
          ) : (
            <Typography variant="label" textStyle="font-medium text-center">
              No Party Information
            </Typography>
          )}
        </div>
        <Typography textStyle="text-[20px] font-medium">
          Uploaded Documents
        </Typography>
        <div className="my-2 lg:flex justify-between items-center flex-wrap ">
          {products.length > 0 ? (
            products.map((item: any, index: number) => (
              // <div className="w-full lg:w-[48%]">
              //   <div
              //     key={index}
              //     className="flex justify-between items-center mb-3 border border-gray-200 w-full  p-3  rounded-lg"
              //   >
              //     <div className="flex justify-start items-center ">
              //       <a target="_blank">
              //         <img src={PDF} className="h-6 w-6" />
              //       </a>
              //       <div className="ml-4">
              //         <p className=" text-gray-400 text-xs ">Document Title</p>
              //         <p className=" text-black font-bold text-sm mt-1">
              //           {item?.title}
              //         </p>
              //       </div>
              //     </div>

              //     {getCase?.payment_status !== "success" ? (
              //       <input
              //         className={`${
              //           waiver === 1 ? "hidden" : "visible"
              //         } border border-gray-300 p-3 rounded-md w-28 h-12`}
              //         value={item?.price}
              //         onChange={(event) => handleInputChange(index, event)}
              //       />
              //     ) : (
              //       <p className="text-green-600 text-xs font-semibold">Paid</p>
              //     )}
              //   </div>

              //   {waiver === 1 && (
              //     <div className="mb-4">
              //       <a
              //         // href={item?.file_path}
              //         onClick={() => {
              //           setBlobUrl(item?.file_path);
              //           setViewOnly(true);
              //         }}
              //         target="_blank"
              //         className="px-2 py-1 bg-brand_indigo text-[#fff] text-xs  w-28  rounded-md"
              //       >
              //         View only
              //       </a>
              //       <button
              //         // onClick={() => addStamp(item?.file_path, item)}
              //         onClick={() => {
              //           handleAppendClick(item?.file_path, item);
              //           setSelectedCaseDocumentId(
              //             item?.id || item?.case_document_id
              //           );
              //         }}
              //         className=" px-2 py-1 bg-brand_indigo text-[#fff] text-xs  w-fit ml-4 rounded-md"
              //       >
              //         Append Stamp
              //       </button>
              //     </div>
              //   )}
              // </div>
              <div className="w-full max-h-[400px] overflow-y-auto py-2">
                <div className="border-[1.1px] rounded-lg px-5 py-3 grid grid-cols-[auto_1fr_80px_64px_128px_128px_128px] items-center gap-x-4 border-[#E9EFF4] w-full">
                  {/* Flag Label */}
                  <div>
                    <span
                      className={`text-[10px] font-semibold px-2 py-1 rounded-full ${getFlagStyle(
                        item?.party_title,
                      )}`}
                    >
                      {item?.party_title.charAt(0).toUpperCase() +
                        item?.party_title.slice(1).toLowerCase()}
                    </span>
                  </div>

                  {/* File Info */}
                  <div className="flex items-center gap-x-4">
                    <img src={PDF_ICON} className="w-6 h-6" alt="PDF" />
                    <div className="flex flex-col">
                      <span className="text-[#292929] text-sm font-medium">
                        {item?.title}
                      </span>
                      <span className="text-[#292929] text-xs">
                        {moment(item?.created_at).format("MM/DD/YYYY")}
                      </span>
                    </div>
                  </div>

                  {/* Price */}
                  {waiver !== 1 &&
                  (item?.status === "UNPAID" || item?.status === "DEFAULT") ? (
                    <input
                      className={`border border-gray-300 p-3 rounded-md w-20 h-[36px] mr-5`}
                      value={item?.price}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  ) : (
                    <div className="text-sm text-[#3A3A49] flex items-center justify-center h-[36px] rounded-lg bg-[#FAFAFB] border-2 border-[#E9EFF4]">
                      {formatCurrency({ iso: "en-ng", slug: "NGN" }).format(
                        item?.price || 0,
                      )}
                    </div>
                  )}

                  {/* View Button */}
                  <button
                    onClick={() => {
                      setBlobUrl(item?.file_path);

                      setViewOnly(true);
                    }}
                    className="hover:opacity-70 shadow-custom text-white text-xs rounded-md bg-brand_indigo h-9 w-full"
                  >
                    View
                  </button>

                  {/* Append Stamp */}
                  <button
                    onClick={() => {
                      // handleAppendClick(item?.file_path, item);
                      // setSelectedCaseDocumentId(item?.id);
                      navigate("/pdf-editor", { state: item });
                    }}
                    className="hover:opacity-70 shadow-custom text-white text-xs rounded-md bg-[#27BBEB] h-9 w-full"
                  >
                    Append Stamp
                  </button>
                  <button
                    onClick={() =>
                      fetchReceipt(item?.id || item?.case_document_id)
                    }
                    className="hover:opacity-70 shadow-custom text-white text-xs rounded-md bg-green-600 h-9 flex items-center justify-center w-full"
                  >
                    {loadingReceipt &&
                    docId === (item?.id || item?.case_document_id) ? (
                      <Loader2 className="w-5 h-5  animate-spin" />
                    ) : (
                      "View Receipt"
                    )}
                  </button>
                  {/* <button
                    onClick={() => {
                      if (!getCase?.suit_number) {
                        toast.error(
                          "Suit number is not available for this case"
                        );
                        return;
                      } else {
                        setSuitNumberBtnClicked("creating");
                        addSuitNumber(
                          item?.file_path,
                          item,
                          getCase?.suit_number
                        );
                      }
                    }}
                    className="hover:opacity-70 shadow-custom text-white text-xs rounded-md bg-[#27BBEB] h-9 w-full"
                  >
                    Append Suit Number
                  </button> */}
                </div>
              </div>
            ))
          ) : getCase?.payment_status !== "success" && products?.length < 1 ? (
            <Typography variant="label" textStyle="font-medium text-center">
              No Uploaded Documents
            </Typography>
          ) : null}
        </div>
        {pdfBytes && (
          <iframe
            src={URL.createObjectURL(
              new Blob([pdfBytes], { type: "application/pdf" }),
            )}
          />
        )}
        {/* <div className="pt-8">
          <Typography textStyle="text-base font-medium ">
            Payment Receipt
          </Typography>
          <div className="my-2 lg:flex justify-between items-center flex-wrap ">
            {paymentReceipt?.length > 0 ? (
              paymentReceipt?.map((item: any, index: number) => (
                <div className="w-full lg:w-[48%]">
                  <div
                    key={index}
                    className="flex justify-between items-center mb-3 border border-gray-200 w-full p-3 rounded-lg cursor-pointer hover:shadow-md transition"
                    onClick={() => {
                      // logic to view receipt image
                    }}
                  >
                    <div className="flex items-center">
                      <img
                        src={item?.file_path || "/placeholder-receipt.jpg"}
                        alt="Receipt Preview"
                        className="h-12 w-12 rounded-md object-cover border"
                      />
                      <div className="ml-4">
                        <p className="text-gray-400 text-xs">Receipt</p>
                        <p className="text-black font-bold text-sm mt-1">
                          {item?.title || "Payment Receipt"}
                        </p>
                        <button
                          onClick={() => {
                            setOpenReceiptViewer(true);
                            setPassReceiptUrl(item?.file_path);
                          }}
                          className="text-blue-500 text-xs mt-1"
                        >
                          Click to view receipt
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              ))
            ) : (
              <Typography variant="label" textStyle="font-medium text-center">
                No payment made for the case folder
              </Typography>
            )}
          </div>
        </div> */}
        <div className={` justify-between lg:flex  items-end`}>
          <div className="w-full lg:w-[40%]">
            <Typography textStyle="text-[20px] font-medium mb-2">
              <>
                Remarks <sup className="text-red-600 text-xs">*</sup>
              </>
            </Typography>

            <textarea
              name="remark"
              placeholder={"Kindly add remarks"}
              className="bg-[#13BAED0D] h-40 w-full resize-none flex justify-start p-4 text-sm"
              value={remark}
              onChange={(e) => {
                setRemark(e.target.value);
                setRemarkRequire("");
              }}
            />
            <small className="text-red-600">{remarkRequire}</small>
          </div>

          <div className="ml-4 w-full lg:w-[30%] mt-2 lg:mt-0">
            {waiver === 1 && getCase?.payment_status !== "success" ? (
              <>
                <Typography textStyle="text-[20px] font-medium text-center">
                  Total
                </Typography>
                <p className="text-center text-green-600 bg-[#D9D9D91A] text-sm text-semibold  p-2 ">
                  <sup className="text-red-700">*</sup> Fee has been been waived
                  !!!
                </p>
              </>
            ) : waiver === 0 && getCase?.payment_status !== "success" ? (
              <>
                <Typography textStyle="text-[20px] font-medium text-center">
                  Total
                </Typography>
                <p className="text-center text-green-600 bg-[#D9D9D91A] text-2xl text-semibold  p-2  min-w-44 rounded-lg">
                  {formatCurrency({ iso: "en-ng", slug: "NGN" }).format(
                    totalPrice ? totalPrice : 0,
                  )}
                </p>
              </>
            ) : getCase?.payment_status === "success" && !hasUnpaidDoc ? (
              <>
                <Typography textStyle="text-[20px] font-medium text-center">
                  Amount Paid
                </Typography>
                <p className="text-center text-green-600 bg-[#D9D9D91A] text-2xl text-semibold  p-2  min-w-44 rounded-lg">
                  {formatCurrency({ iso: "en-ng", slug: "NGN" }).format(
                    getCase?.amount_paid,
                  )}
                </p>
              </>
            ) : (
              hasUnpaidDoc && (
                <>
                  <Typography textStyle="text-[20px] font-medium text-center">
                    Amount To Be Paid
                  </Typography>
                  <p className="text-center text-green-600 bg-[#D9D9D91A] text-2xl text-semibold  p-2  min-w-44 rounded-lg">
                    {formatCurrency({ iso: "en-ng", slug: "NGN" }).format(
                      totalPrice ? totalPrice : 0,
                    )}
                  </p>
                </>
              )
            )}
            <a
              type="button"
              className="text-sm mt-2 flex justify-center items-center w-full cursor-pointer"
              onClick={() => dispatch(setToggle_2(true))}
            >
              <img src={QUESTION} className="h-4" />{" "}
              <span className="mx-1">{` Information on `}</span>
              <span className="text-brand_blue font-bold">{` filing fees`}</span>
            </a>
          </div>
        </div>
        <div className="w-full md:flex justify-between items-end mt-10">
          <div className="w-full lg:w-[45%] flex justify-between items-center flex-wrap">
            <Button
              icons={CHEVRON_LEFT}
              iconClassName="h-[0.9rem] w-3"
              title="Back"
              bgColor={"bg-brand_indigo"}
              onClick={() => navigate("/registrar-1/case-folders")}
              hoverColor={""}
              textColor={"text-white"}
              className={"py-3 w-32 hidden md:flex"}
            />
            {activeCaseInView?.payment_status !== "success" && (
              <Button
                isLoading={rjloading}
                icons={MINUS}
                iconClassName="h-[0.9rem] w-3"
                title="Reject  Folder"
                bgColor={"bg-red-600"}
                onClick={() => handleReject()}
                hoverColor={""}
                textColor={"text-white"}
                className={"py-3 w-40 lg:w-44"}
              />
            )}
            <div className="w-40 md:w-44 md:hidden">
              <Button
                isLoading={loading}
                icons={FLAG}
                iconClassName="h-[0.9rem] w-3"
                title={
                  waiver === 1 ? "Submit to Registrar 2" : "Advised  Payment"
                }
                bgColor={"bg-[#27AE60]"}
                onClick={() =>
                  waiver === 1
                    ? handleSubmitToRegistrar_2()
                    : handleAdvisePayment()
                }
                hoverColor={""}
                textColor={"text-white"}
                className={"py-3 w-full"}
              />
            </div>
          </div>

          <div className="w-[30%] md:w-44 mx-auto lg:mx-0 mt-3 lg:mt-0">
            <Button
              icons={CHEVRON_LEFT}
              iconClassName="h-[0.9rem] w-3"
              title="Back"
              bgColor={"bg-brand_indigo"}
              onClick={() => navigate("/registrar-1/case-folders")}
              hoverColor={""}
              textColor={"text-white"}
              className={"py-3 w-32 md:hidden flex"}
            />
            <Button
              isLoading={loading}
              icons={FLAG}
              iconClassName="h-[0.9rem] w-3"
              title={waiver === 1 ? "Submit to Registrar 2" : "Advise  Payment"}
              bgColor={"bg-[#27AE60]"}
              onClick={() =>
                waiver === 1
                  ? handleSubmitToRegistrar_2()
                  : handleAdvisePayment()
              }
              hoverColor={""}
              textColor={"text-white"}
              className={"py-3 w-full hidden md:flex"}
            />
          </div>
        </div>
        {/* {HandleOpenDoc()} */}
        {HandleViewOnlyDoc()} {/* Conditionally render the modal */}
        {HandleViewReceipt()}
        <PartyInformation
          open={toggleStatus}
          close={() => dispatch(setToggle(false))}
          data={singlePartyInfo}
        />
        <FillingFee
          open={toggleStatus_2}
          close={() => dispatch(setToggle_2(false))}
        />
        <Preloader
          preloaderState={
            preloaderState ||
            pageLoaderState ||
            suitNumberBtnClicked ||
            verifyLoader ||
            pageLoader
          }
          action={
            preloaderState === "creating"
              ? "Appending stamp"
              : pageLoaderState
                ? "Fetching pdf pages"
                : suitNumberBtnClicked
                  ? "Appending suit number"
                  : verifyLoader === "creating"
                    ? "Verifying payment"
                    : pageLoader === "creating"
                      ? "Loading case folder"
                      : ""
          }
        />
      </div>
      <ViewReceiptModal />
    </>
  );
}

export default ProcessPayment;

//  {getCase?.payment_status === "success" &&
//           getCase?.case_documents?.length > 0 ? (
//             getCase?.case_documents.map((item: any, index: number) => (
//               <div className="w-full lg:w-[48%]">
//                 <div
//                   key={index}
//                   className="flex justify-between items-center mb-3 border border-gray-200 w-full  p-3  rounded-lg"
//                 >
//                   <div className="flex justify-start items-center ">
//                     <a target="_blank">
//                       <img src={PDF} className="h-6 w-6" />
//                     </a>
//                     <div className="ml-4">
//                       {/* <p className=" text-gray-400 text-xs ">Document Title</p> */}
//                       <p className=" text-black font-bold text-sm mt-1">
//                         {item?.joined}
//                       </p>
//                     </div>
//                   </div>

//                   <div>
//                     <p className="text-center text-gray-400 text-xl  border-gray-300 rounded-lg">
//                       {formatCurrency({ iso: "en-ng", slug: "NGN" }).format(
//                         item?.price
//                       )}
//                     </p>
//                     <p className="text-green-600 text-md font-semibold text-center">
//                       Paid
//                     </p>
//                   </div>
//                 </div>

//                 {waiver === 1 && (
//                   <div className="mb-4">
//                     <a
//                       //   href={item?.file_path}
//                       onClick={() => {
//                         setBlobUrl(item?.file_path);
//                         setViewOnly(true);
//                       }}
//                       target="_blank"
//                       className="px-2 py-1 bg-brand_indigo cursor-pointer text-[#fff] text-xs  w-28  rounded-md"
//                     >
//                       View only
//                     </a>

//                     <button
//                       // onClick={() => addStamp(item?.file_path, item)}
//                       onClick={() => {
//                         handleAppendClick(item?.file_path, item);
//                         setSelectedCaseDocumentId(
//                           item?.id || item?.case_document_id
//                         );
//                       }}
//                       className=" px-2 py-1 bg-brand_indigo text-[#fff] text-xs  w-fit ml-4 rounded-md"
//                     >
//                       Append Stamp
//                     </button>
//                   </div>
//                 )}
//               </div>
//             ))
//           ) : getCase?.payment_status === "success" &&
//             getCase?.case_documents?.length > 1 ? (
//             <Typography variant="label" textStyle="font-medium text-center">
//               No Uploaded Documents
//             </Typography>
//           ) : null}
